(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lyckoplatsen/components/shared-charity-payout/assets/utils/charity-utils.js') >= 0) return;  svs.modules.push('/modules/lyckoplatsen/components/shared-charity-payout/assets/utils/charity-utils.js');
"use strict";


const doesPayoutChartContainData = payoutData => {
  var _payoutData$data;
  if ((payoutData === null || payoutData === void 0 || (_payoutData$data = payoutData.data) === null || _payoutData$data === void 0 ? void 0 : _payoutData$data.length) > 0) {
    const totalPercentage = payoutData.data.reduce((sum, item) => sum + item.percentageOfTotal, 0);
    return totalPercentage > 0;
  }
  return false;
};
setGlobal('svs.lyckoplatsen.shared_charity_payout.utils', {
  doesPayoutChartContainData
});

 })(window);